import React, { useMemo } from 'react';
import useLinkProps from '../../hooks/useLinkProps';
import handleStickyFocus from '../../utils/handleStickyFocus';
import useNavItemStyles from './utils/useNavItemStyles';
import ItemBody from './ItemBody';
const withLinkNavItem = (Component) => React.forwardRef((props, ref) => {
    const { children, to, description, infoText, styles, isWarning } = props;
    const { isHovered, isFocused, ...rest } = useLinkProps(to, children);
    const onClick = handleStickyFocus(rest.onBlur);
    const style = useNavItemStyles(isFocused || isHovered, styles);
    const processedProps = useMemo(() => ({
        ...rest,
        onClick,
        style
    }), [style, rest, onClick]);
    const navBody = (React.createElement(ItemBody, { description: description, infoText: infoText, isWarning: isWarning }, rest.children));
    return 'to' in processedProps ? (React.createElement(Component, { ...processedProps, ref: ref }, navBody)) : (React.createElement("a", { ...processedProps }, navBody));
});
export default withLinkNavItem;
//# sourceMappingURL=withLinkNavItem.js.map